import { render, staticRenderFns } from "./ExaminationRoom.vue?vue&type=template&id=6e3ec15c&scoped=true&"
import script from "./ExaminationRoom.vue?vue&type=script&lang=js&"
export * from "./ExaminationRoom.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationRoom.vue?vue&type=style&index=0&id=6e3ec15c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3ec15c",
  null
  
)

export default component.exports